import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CcService } from '../../../services/cc.service';
import { DataService } from '../../../services/data.service';
import { SecurityService } from '../../../services/security.service';
import { ErrorStateMatcher1 } from '../../error-state-matcher1';
import { IccEdit, IccResponse } from '../../Interfaces/icc';
import { IdatatableResponse } from '../../Interfaces/idatatable';
import { IResponse } from '../../Interfaces/iresponse';

@Component({
  selector: 'app-ccedit',
  templateUrl: './ccedit.component.html'
})

export class CcEditComponent implements OnInit {
  formCcedit: FormGroup;
  subRef$: Subscription;
  matcher = new ErrorStateMatcher1();
  mensaje: string = "";
  cccode: string = "";

  constructor(
    private formBuilder: FormBuilder, 
    private dataService: DataService,
    private securityService: SecurityService,
    private router: Router,
    private ccservice: CcService,
    private _snackBar: MatSnackBar
  ) {
    this.formCcedit = formBuilder.group({
      name: ['', Validators.required],
      telephone1: ['', Validators.required],
      email1: ['', Validators.required],
      address1: ['', Validators.required],
      type: ['', Validators.required],
    });
  }
  selectedvalue: number; selectedview: string;
  typelist: { type: string; description: string; }[];


  ngOnInit() {
    this.mensaje = "";
    //tipos de id
    this.typelist = [];
    let url = environment.urlAPI + 'api/datatable/';
    this.dataService.get<IdatatableResponse[]>(url + "CCTYP").subscribe(results => {
      if (results.ok) {
        for (const entry of results.body) {
          //this.Addtype({ typeid: entry.id, table: entry.table, code: entry.code, textvalue: entry.textvalue, numericvalue: entry.numericvalue, datevalue: entry.datevalue, boolvalue: entry.boolvalue });
          this.typelist.push({ type:entry.code,  description: entry.textvalue });
        }
      }
    }, (e) => {
      console.log(e);
    });
    this.ccservice.GetCCData(this.ccservice.ccID).subscribe(results => {
      if (results.body.isValid) {
        this.cccode = results.body.resultData.code;
        this.formCcedit.controls['name'].setValue(results.body.resultData.name);
        this.formCcedit.controls['telephone1'].setValue(results.body.resultData.telephone1);
        this.formCcedit.controls['email1'].setValue(results.body.resultData.email1);
        this.formCcedit.controls['address1'].setValue(results.body.resultData.address1);
        this.formCcedit.controls['type'].setValue(results.body.resultData.type);
      }
    },
      (e) => {
        this.mensaje = e.error;
        console.log(e);
      });
  }

  Grabar()
  {
    try {
      const iccedit: IccEdit = {
        id:this.ccservice.ccID,
        name: this.formCcedit.value.name,
        telephone1: this.formCcedit.value.telephone1,
        email1: this.formCcedit.value.email1,
        address1: this.formCcedit.value.address1,
        type: this.formCcedit.value.type
      };
      const url = environment.urlAPI + 'api/cc/';
      this.dataService.put<IResponse>(url,iccedit).subscribe(results => {
        if (results.ok) {
          this.openSB(results.body.response);
          this.router.navigate(['/cclist']);
        }
        else { alert("Error"); }
      },
        (e) => {
          alert(e.error);
        }
      );
    }
    catch (e) {
      console.log(e.message);
      alert(e.message);
    }
  }

  Cancelar()
  {
          this.router.navigate(['/cclist']);
  }



  hasError(nombreControl: string, validacion: string) {
    const control = this.formCcedit.get(nombreControl);
    return control.hasError(validacion);
  }

  openSB(msg) {
    this._snackBar.open(msg,'', {
      duration: 5000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }


}
